// extracted by mini-css-extract-plugin
export var closeButton = "_f8-2";
export var closeButtonIcon = "_f8-3";
export var lightboxContent = "_f8-1";
export var lightboxOverlay = "_f8-0";